module.exports = __webpack_public_path__ + "img/bank-example-2.07b2274b.png";